<template>
  <b-row>
    <b-col cols="12">
      <TableComponents
        v-if="!showForm"
        :columns="columns"
        :rows="listaConselhos"
        title-table="Conselho"
        module="conselhoSettingsModule"
        sort-name="descricao"
        :add-permission="'ROLE_CONSELHO_INSERIR'"
        :view-permission="'ROLE_CONSELHO_CONSULTAR'"
        :edit-permission="'ROLE_CONSELHO_ATUALIZAR'"
        :delete-permission="'ROLE_CONSELHO_DELETAR'"
        :search-field="'descricao'"
        @add="addNew"
        @edit="edit"
      />
      <FormConselho
        v-else
        @cancelar="cancelar"
      />
    </b-col>
  </b-row>
</template>
<script>
import { mapState } from 'vuex'
import TableComponents from '@/layouts/components/TableComponents.vue'
import { BRow, BCol } from 'bootstrap-vue'
import FormConselho from './forms/FormConselho.vue'

export default {
  components: {
    BRow,
    BCol,
    TableComponents,
    FormConselho,
  },
  computed: {
    ...mapState('conselhoSettingsModule', {
      listaConselhos: state => state.listaConselhos,
    }),
  },
  data() {
    return {
      showForm: false,
      columns: [
        {
          label: 'Id',
          field: 'id',
        },
        {
          label: 'Descrição',
          field: 'descricao',
        },
        {
          label: 'Sigla',
          field: 'sigla',
        },
        {
          label: 'Ativo',
          field: 'ativo',
        },
        {
          label: 'Action',
          field: 'action',
        },
      ],
    }
  },
  methods: {
    addNew() {
      this.$store.dispatch('conselhoSettingsModule/resetConselho')
      this.showForm = true
    },
    edit(data) {
      this.$store.dispatch('conselhoSettingsModule/prepareToEditConselho', data)
      this.showForm = true
    },
    cancelar() {
      this.showForm = false
    },
  },
}
</script>
